<template>
  <slot :submit="submit" :submitted="submitted" :submitting="submitting" :errors="errors" :html="html"></slot>
</template>
<script>
/* globals $ App */

export default {
  props: {
    formId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      properties: undefined,
      submitted: false,
      submitting: false,
      html: null,
      errors: [],
      forms: null,
    };
  },
  created() {
    this.getFormProperties();
    App.getForms().then((forms) => {
      this.forms = forms;
    });
  },
  methods: {
    async submit(data) {
      if (!this.properties || !this.form) {
        return;
      }
      this.submitting = true;
      this.errors = [];
      if (this.properties.captchas[0] ?? null) {
        await this.forms.getCaptchaToken(this.properties.captchas[0].action).then((value) => {
          data[this.properties.captchas[0].name] = value;
        });
      }
      data[this.properties.csrf.name] = this.properties.csrf.token;
      data.formHash = this.properties.hash;
      data.freeform_payload = this.properties.freeform_payload;
      $.ajax({
        url: `/?action=freeform/submit`,
        data: data,
        method: "POST",
      }).done((data) => {
        if (data.success) {
          this.submitted = true;
          this.html = data.html || null;
        } else {
          this.errors = data.formErrors;
        }
        this.submitting = false;
      });
    },
    getFormProperties() {
      $.ajax({
        url: `/?action=swissmed/freeform/form-properties&id=${this.formId}`,
      }).done((data) => {
        this.properties = data;
      });
    },
  },
};
</script>
